export const Godhra = {
    title: "Godhra",
    title1: "(Cultural & Historical Attractions)",

    attractions: [
        {
            name: "Champaner-Pavagadh Archaeological Park",
            description: "A UNESCO World Heritage Site, this historical park is home to ancient forts, temples, and stepwells, offering a glimpse into Gujarat's rich past.",
            location: "Near Godhra, Gujarat",
            timings: "8:30 AM to 5:30 PM",
            ticket: "INR 30 (Indian Citizens), INR 500 (Foreigners)",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Explore ancient ruins",
                "Visit the famous Kalika Mata Temple",
                "Enjoy panoramic views from Pavagadh Hill"
            ],
            mapLink: "https://maps.app.goo.gl/champanerpavagadh",
        },
        {
            name: "Shree Gangeshwar Mahadev Temple",
            description: "A revered Shiva temple known for its peaceful surroundings and spiritual ambiance, attracting devotees throughout the year.",
            location: "Godhra, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "During Mahashivratri",
            activities: [
                "Offer prayers and perform rituals",
                "Attend religious ceremonies",
                "Explore the temple architecture"
            ],
            mapLink: "https://maps.app.goo.gl/gangeshwarmahadev",
        },
        {
            name: "Kanelav Lake",
            description: "A serene lake surrounded by lush greenery, perfect for relaxation, boating, and birdwatching.",
            location: "Godhra, Gujarat",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Enjoy a peaceful lakeside walk",
                "Go boating and fishing",
                "Birdwatching and photography"
            ],
            mapLink: "https://maps.app.goo.gl/kanelavlake",
        },
        {
            name: "Bhagwan Parshwanath Jain Derasar",
            description: "A beautifully crafted Jain temple with intricate marble carvings, attracting devotees and tourists interested in Jain heritage.",
            location: "Godhra, Gujarat",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Offer prayers and meditate",
                "Explore temple carvings",
                "Attend religious discourses"
            ],
            mapLink: "https://maps.app.goo.gl/parshwanathderasar",
        },
        {
            name: "Madhav Baug",
            description: "A well-maintained garden offering a refreshing green space for relaxation, family outings, and morning walks.",
            location: "Godhra, Gujarat",
            timings: "5:00 AM to 10:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Relax amidst greenery",
                "Enjoy a peaceful walk",
                "Playground activities for kids"
            ],
            mapLink: "https://maps.app.goo.gl/madhavbaug",
        }
    ]
};
